
<form [formGroup]="form" class="passwordForm">


	<mat-form-field appearance="outline" style="width: 100%;">

		<input matInput
			placeholder="Neues Passwort"
			formControlName="newPassword"
			[type]="hideNewPassword ? 'password' : 'text'"
			autocomplete="new-password">
		<mat-icon matSuffix style="cursor:pointer" (click)="hideNewPassword = !hideNewPassword">
			{{hideNewPassword ? 'visibility' : 'visibility_off'}}
		</mat-icon>

		<mat-error *ngIf="form.controls['newPassword'].hasError('required')">
			Please enter a new password
		</mat-error>

	</mat-form-field>

	<mat-form-field appearance="outline" style="width: 100%;">
		<input matInput
			placeholder="Passwort Bestätigung"
			formControlName="newPasswordConfirm"
			[type]="hideNewPassword ? 'password' : 'text'"
			autocomplete="new-password">
		<mat-icon matSuffix style="cursor:pointer" (click)="hideNewPassword = !hideNewPassword">
			{{hideNewPassword ? 'visibility' : 'visibility_off'}}
		</mat-icon>

		<mat-error *ngIf="form.controls['newPasswordConfirm'].hasError('required')">
			Please confirm your new password
		</mat-error>
	</mat-form-field>

	<p style="text-align: left;">
		Ein sicheres Passwort enthält 12 Zeichen, 1 Zahl,
		1 Symbol (!"#$%&'*+,-./:;=?&#64;[]\^_`|~),
		1 Großbuchstaben und 1 Kleinbuchstaben
	</p>

	<button mat-raised-button color="primary"
		[disabled]="form.invalid || disableSubmit"
		(click)="changePassword()">
		Speichern
	</button>

	<p style="font-size: larger; color: red; text-align: left;">{{errorMsg}}</p>


</form>

